import { HeaderConstructor } from '@services/MarppleShop/renderApp/components/cells/Header/libs/types/header';
import { rune } from 'rune-ts';

export const getHeader = (header: HeaderConstructor) => {
  const header_el = document.querySelector(`.${header}`);

  if (!header_el) return;

  return rune.getView(header_el, header);
};
